<style>

.floor-plans {
    font-size: 1rem;
    margin-top: 6rem;
}

.floor-plans div img {
    width: 100%;
}

.floor-plans .plan-header {
    border-bottom: 1px solid white;
    margin-bottom: 1rem;
}

</style>

<template>

<div class="p-4 lg:w-container mx-auto mt-0 md:mt-4">

    <div class="flex flex-col justify-center floor-plans">

        <div>SAMPLE TEST-FITS</div>
        <div class="text-gray">Column-free Floor Plate
            <br /> 10-foot Finished Ceilings</div>


        <div class="flex flex-wrap">


            <div class="w-full sm:w-1/2 self-center">
                <p class="plan-header">BASE </p>
                <p class="text-gray">2nd—6th Floor 4,524 RSF </p>
                <br class="hidden md:block" />

                <a href="https://customize.thesix56.com/configure?floor=lowrise" class="button hidden sm:inline">Customize Floor Plan </a>
                <br class="hidden md:block" />
                <br class="hidden md:block" />
                <a href="/pdf/sixlow.pdf" class="button">Download</a>
            </div>
            <div class="w-full sm:w-1/2 p-10 order-first sm:order-last"> <img src="/images/plan-2nd.png" /></div>

        </div>
        <div class="flex flex-wrap">


            <div class="w-full sm:w-1/2 self-center">


                <p class="plan-header">MIDRISE </p>
                <p class="text-gray">14th—16th Floor 3,051 RSF </p>
                <br class="hidden md:block" />
                <a href="https://customize.thesix56.com/configure?floor=midrise" class="button hidden sm:inline">Customize Floor Plan </a>
                <br class="hidden md:block" />
                <br class="hidden md:block" />
                <a href="/pdf/sixmid.pdf" class="button">Download</a>

            </div>
            <div class="w-full sm:w-1/2 p-10 order-first sm:order-last"> <img src="/images/plan-mid.png" /></div>
        </div>
        <div class="flex flex-wrap">

            <div class="w-full sm:w-1/2 self-center">


                <p class="plan-header">TOWER </p>
                <p class="text-gray">17th—19th Floor 2,682 RSF
                    <br/>20th—24th Floor 2,483 RSF
                    <br/>25th—26th Floor 2,492 RSF </p>
                <br class="hidden md:block" />
                <a href="https://customize.thesix56.com/configure?floor=highrise" class="button hidden sm:inline">Customize Floor Plan </a>
                <br class="hidden md:block" />
                <br class="hidden md:block" />
                <a href="/pdf/sixhigh.pdf" class="button">Download</a>


            </div>
            <div class="w-full sm:w-1/2 p-10 order-first sm:order-last"> <img src="/images/plan-tower.png" /></div>

        </div>



    </div>

</div>

</template>

<script>

export default {
    name: 'floor-plan',
}

</script>
